<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import api from '@/api';
import { PageName } from '@/api/tracking';
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import { SurveyExecutionFrom } from '@/types';

const props = defineProps<{
  groupId: number;
  pageName: PageName;
}>();

const router = useRouter();
const route = useRoute();

const pageNameToFrom: Partial<Record<PageName, SurveyExecutionFrom>> = {
  group_marks: 'group_marks_page',
  group_activities: 'group_activity_page',
};

const navigateToSurvey = () => {
  api.trackEvent('survey_open', {
    pageName: props.pageName,
    pageUrl: route.fullPath,
    feature: 'survey', // この時点でsurveyを使っていることとする。
  });
  router.push({
    name: 'surveyTop',
    query: {
      mode: 'group_marks',
      group_id: props.groupId.toString(),
      from: pageNameToFrom[props.pageName],
    },
  });
};
</script>

<template>
  <button
    class="group-survey-button c-btn c-btn--small c-btn--primary"
    type="button"
    @click="navigateToSurvey"
  >
    <DgrIcon size="small" name="sparkles-fill" :keep-fill="false" />
    グループマークした情報から質問
  </button>
</template>

<style scoped lang="scss">
.group-survey-button {
  width: max-content;
  gap: 4px;

  .icon-box {
    color: $color-white;
  }
}
</style>
